




















import Vue from 'vue';
import TopNav from '@/web/components/navigation/TopNav.vue';
import NavItem from '@/web/components/navigation/NavItem.vue';
import { mapGetters } from 'vuex';
import { notify } from '@/web/utils/notify';

import CouponForm from '@/web/components/coupons/CouponForm.vue';
import DirtyMixin from '@/web/mixins/DirtyMixin';
import { ValidationObserver } from 'vee-validate';
import { errorToMessage, scrollToFirstFormError } from '@/core/utils/errors';
import moment from 'moment';

interface LocalState {
  coupon: CreateCouponRequest;
  inProgress: boolean;
  date: DatePicker;
}

export default Vue.extend({
  name: 'CreateCoupon',
  mixins: [DirtyMixin],
  data(): LocalState {
    return {
      coupon: {
        code: '',
        name: '',
        discount_amount: '',
        discount_type: 'fixed_amount',
        duration_type: 'unlimited',
        duration_units: 1,
        max_redemptions: '',
        redeem_end: moment().add(7, 'days').format(),
        redeem_start: new Date().toDateString(),
        products: [],
      },
      inProgress: false,
      date: {
        startDate: new Date(),
        endDate: new Date(),
      },
    };
  },
  components: {
    TopNav,
    NavItem,
    CouponForm,
    ValidationObserver,
  },
  methods: {
    navigateToAllCoupons(): void {
      this.$router.push('/products/coupons/');
    },
    async save(): Promise<void> {
      if (this.inProgress) {
        return;
      }
      this.$refs.form.validate();
      if (this.$refs.form.flags.invalid) {
        scrollToFirstFormError();
        return;
      }
      this.inProgress = true;
      try {
        if (this.coupon) {
          this.coupon.redeem_start = moment(this.date.startDate).format(
            'YYYY-MM-DD'
          );
          this.coupon.redeem_end = moment(this.date.endDate).format(
            'YYYY-MM-DD'
          );
          this.coupon.products = this.coupon.products.map(p => p.id);
        }
        await this.$store.dispatch('product/createCoupon', this.coupon);
        this.clearDirty();
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t('PRODUCTS.MODAL.COUPON_CREATED_DESCRIPTION'),
        });
        this.navigateToAllCoupons();
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to create the coupon',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
      this.inProgress = false;
    },
  },
});
